import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20d73a1d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d73a1d')) {
      api.createRecord('20d73a1d', component.options)
    } else {
      api.reload('20d73a1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20d73a1d", function () {
      api.rerender('20d73a1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/kpiSet/sopTotal/index.vue"
export default component.exports